import { useState, useEffect } from "react";
import { Languages } from "lucide-react";

const LanguageTabs = ({ languages, defaultLang = "en", value = "en", onChange }) => {
  const activeLang = value || defaultLang;

  return (
    <div className="flex items-center gap-2 border-b border-gray-200 pb-2 mt-3 mb-2">
      <Languages className="w-5 h-5 text-gray-600" />
      <div className="flex gap-2">
        {languages.map((lang) => (
          <>
            {/* <div className="border-primary">{lang.code}</div> */}
            <div
              key={lang.code}
              // onClick={() => setActiveLang(lang.code)}
              onClick={() => onChange(lang.code)}
              className={`px-3 py-1 rounded-lg text-sm font-medium transition cursor-pointer ${
                activeLang === lang.code ? "bg-primary text-white" : "bg-gray-100 text-gray-700 hover:bg-gray-200"
              }`}>
              {lang.label}
            </div>
          </>
        ))}
      </div>
    </div>
  );
};

export default LanguageTabs;
